<template>
    <div class="antialiased">
      <Sidebar />
      <div class="page">
        <Header></Header>
        <div class="content">
            <div class="container">
                <!-- Page title -->
                <div class="page-header pb-4 border-bottom">
                    <div class="d-flex justify-content-between">
                        <h2 class="page-title">Realisasi Kunjungan Salesman</h2>
                        
                        <div class="col-auto btn-group">
                            <button
                                class="btn btn-white"
                                v-html="ic('filter') + ' Filter'"
                                @click="_filter"
                            ></button>
                            <button
                                class="btn btn-outline-primary"
                                @click="_createExcel"
                                :disabled="report.length == 0"
                                v-html="isExcelDownload ? spin() : ic('download') + ' Export Excel'
                                "
                            ></button>
                        </div>
                    </div>
                </div>
                <div class="alert alert-info" v-if="!isFilter">
                    <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat Laporan Realisasi Kunjungan Salesman
                </div>
                <Nodata v-if="!loading && report.length == 0"/>
                <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
                <section class="px-4" v-if="!loading && report.length > 0" style="overflow: auto; max-height: 650px">
                    <section class="card p-4" v-for="(kunjungan, index) in report" :key="index">
                        <section class="row px-3 mb-3">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Nama Sales</td>
                                        <td>: {{kunjungan.nama_sales}} ({{ kunjungan.nama_tim }})</td>
                                        <td>Call</td>
                                        <td>: {{kunjungan.total_route}} </td>
                                        <td>Tanggal</td>
                                        <td class="text-capitalize">: {{ kunjungan.hari }} , {{dateFormat(kunjungan.tanggal)}} </td>
                                    </tr>
                                    <tr>
                                        <td>Nama SPV</td>
                                        <td>: {{kunjungan.nama_sales_supervisor}}</td>
                                        <td>EC</td>
                                        <td>: {{kunjungan.total_order}}</td>
                                        <td>Efektif Rata Rata Kunjungan</td>
                                        <td>: {{kunjungan.average_kunjungan.toFixed(2)}} </td>
                                    </tr>
                                    <tr>
                                        <td>Jam Berangkat</td>
                                        <td>: {{dFormat(kunjungan.jam_berangkat,'H:m:s')}}</td>
                                        <td>EC Route</td>
                                        <td>: {{kunjungan.total_order_route}}</td>
                                        <td>Jam Efektif</td>
                                        <td>: {{kunjungan.total_durasi_kunjungan.toFixed(2)}} Menit</td>
                                    </tr>
                                    <tr>
                                        <td>Jam Toko Pertama</td>
                                        <td>: {{dFormat(kunjungan.jam_pertama_masuk_toko, 'H:m:s')}}</td>
                                        <td>EC Non Route</td>
                                        <td>: {{kunjungan.total_order_non_route}}</td>
                                    </tr>
                                    <tr>
                                        <td>Jam Toko Terakhir</td>
                                        <td>: {{dFormat(kunjungan.jam_terkahir_kembali_toko, 'H:m:s')}}</td>
                                        <td>Omset Value</td>
                                        <td>: {{ribuan(kunjungan.total_order_value.toFixed(2))}}</td>
                                    </tr>
                                    <tr>
                                        <td>Jam Balik</td>
                                        <td>: {{kunjungan.jam_kembali ? dFormat(kunjungan.jam_kembali,'H:m:s') : '-'}}</td>
                                        <td>Omset Volume</td>
                                        <td>: {{kunjungan.total_order_in_carton.toFixed(2)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <section>
                            <div class="card" style="overflow: auto; max-height: 350px">
                                <table
                                    class=" table table-vcenter table-hover card-table table-striped table-control"
                                >
                                    <thead>
                                        <tr class="text-muted">
                                            <th>Nama Toko</th>
                                            <th>Alamat</th>
                                            <th>Tipe Kunjungan</th>
                                            <th style="width: 10%;">Jam Masuk/Keluar</th>
                                            <th>Waktu di Toko</th>
                                            <th>Omset Value</th>
                                            <th>Omset Volume</th>
                                            <th>Status</th>
                                            <th>Keterangan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(detailKunjungan, indexDetail) in kunjungan.detail_kunjungan" :key="indexDetail">
                                            <td>{{ detailKunjungan.nama_toko }}</td>
                                            <td>{{ detailKunjungan.alamat_toko }}</td>
                                            <td>{{ detailKunjungan.tipe }}</td>
                                            <td class="item-center">
                                                <div class="btn btn-light btn-sm">
                                                    {{ detailKunjungan.absen_masuk ? dFormat(detailKunjungan.absen_masuk, 'H:m') : '-'}} / 
                                                    {{ detailKunjungan.absen_keluar ? dFormat(detailKunjungan.absen_keluar, 'H:m') : '-'}}
                                                </div>
                                            </td>
                                            <td>{{ detailKunjungan.durasi_kunjungan ? detailKunjungan.durasi_kunjungan : '-'  }}</td>
                                            <td>{{ ribuan(detailKunjungan.grand_total_order) }}</td>
                                            <td>{{ detailKunjungan.total_order_in_carton }}</td>
                                            <td>{{ detailKunjungan.status }}</td>
                                            <td>{{ detailKunjungan.keterangan }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </section>
                </section>
            </div>
        </div>
      </div>

      <!-- Section Modals -->
      <FormFilter
        :isOpen.sync="modals.filter.view"
        @submit="modals.filter.action"
        />
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import XLSX from 'xlsx';
import { dateFormat } from "highcharts";

export default {
    name: "LaporanKunjunganSalesman",
    components: { FormFilter },

    data() {
        return{
            loading: false,
            isFilter: false,
            isExcelDownload: false,
            date: false,
            report: [],
            modals:{
                filter:{
                    view: false,
                    action: () => {}
                }
            }
        }
    },
    mixins: [helper],
    methods: {
        _filter(){
            this.modals.filter.view = true
            this.modals.filter.action = async (filter) => {
                this.loading = true;
                this.report = [],
                this.axios.get("kunjungan_sales/report", {params: filter})
                    .then((res) => {
                        this.isFilter = true;
                        this.date = filter.tanggal;
                        this.report = res.data.data
                    })
                    .catch((err) => {
                        this.onError(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },

        _createExcel(){
            this.isExcelDownload = true;
            const workbook = XLSX.utils.book_new();
            for (const reportPerTim of this.report) {
                let reportKunjungan = [
                    [""],
                    [""],
                    ["","Nama Sales", reportPerTim.nama_sales, "Call", reportPerTim.total_route, "Tanggal", this.dateFormat(reportPerTim.tanggal)],
                    ["","Nama SPV", reportPerTim.nama_sales_supervisor, "EC", reportPerTim.total_order, "Efektif Rata Rata Kunjungan", reportPerTim.average_kunjungan.toFixed(2)],
                    ["","Jam Berangkat",  reportPerTim.jam_berangkat ? this.dFormat(reportPerTim.jam_berangkat, 'H:m:s') : '-', "EC Rute", reportPerTim.total_order_route, "Jam Efektif", reportPerTim.total_durasi_kunjungan.toFixed(2)],
                    ["","Jam Toko Pertama",  reportPerTim.jam_pertama_masuk_toko ? this.dFormat(reportPerTim.jam_pertama_masuk_toko, 'H:m:s') : '-', "EC Non Rute", reportPerTim.total_order_non_route],
                    ["","Jam Toko Terakhir",  reportPerTim.jam_pertama_masuk_toko ? this.dFormat(reportPerTim.jam_pertama_masuk_toko, 'H:m:s') : '-', "Omset Value", reportPerTim.total_order_value.toFixed(2)],
                    ["","Jam Toko Balik",  reportPerTim.jam_kembali ? this.dFormat(reportPerTim.jam_kembali, 'H:m:s') : '-', "Omset Volume", reportPerTim.total_order_in_carton.toFixed(2)],
                    [""],
                    ["","Nama Toko","Alamat","Tipe Kunjungan","Jam Masuk","Jam Keluar","Waktu di Toko","Omset Value","Omset Volume","Status","Keterangan"],
                ];
                for (const kunjungan of reportPerTim.detail_kunjungan) {
                    reportKunjungan.push([
                        "",
                        kunjungan.nama_toko,
                        kunjungan.alamat_toko,
                        kunjungan.tipe,
                        kunjungan.absen_masuk ? this.dFormat(kunjungan.absen_masuk, 'H:m:s') : '-',
                        kunjungan.absen_keluar ? this.dFormat(kunjungan.absen_keluar, 'H:m:s') : '-',
                        kunjungan.durasi_kunjungan ? kunjungan.durasi_kunjungan : '-',
                        kunjungan.grand_total_order,
                        kunjungan.total_order_in_carton,
                        kunjungan.status,
                        kunjungan.keterangan
                    ]);
                }
                const sheet_data = XLSX.utils.aoa_to_sheet(reportKunjungan);
                sheet_data['!cols'] = this.fitToColumnWidth(reportKunjungan);
                const sheet_name = `${reportPerTim.nama_sales} (${reportPerTim.nama_tim})`;
                XLSX.utils.book_append_sheet(workbook, sheet_data, sheet_name); 
            }
            XLSX.writeFile(workbook, `report-kunjungan-salesman-${this.date}.xlsx`);
            this.isExcelDownload = false;
        }
    }
}
</script>
